import { isMobile } from "react-device-detect";

import DropDownListMobile from "./mobile";
import { Props } from "./types";
import DropDownListWeb from "./web";

export function DropDownList(props: Props) {
	const defaultProps = {
		valueProp: "value",
		textProp: "label",
		loaded: true,
		highlightedValues: new Set<any>(),
	} as Props;
	// A native multiple select is a list box in desktop browsers, so multi stays on react-select
	if (isMobile && !props.isMulti) return <DropDownListMobile {...defaultProps} {...props} />;
	return <DropDownListWeb {...defaultProps} {...props} />;
}

export * from "./async";
